export default __webpack_public_path__ + "static/media/sec1_right.0251f7ae.png";